/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
import { NoopLogger } from './NoopLogger';
export class NoopLoggerProvider {
    getLogger(_name, _version, _options) {
        return new NoopLogger();
    }
}
export const NOOP_LOGGER_PROVIDER = new NoopLoggerProvider();
//# sourceMappingURL=NoopLoggerProvider.js.map